import React from 'react'
import { useRouter } from 'next/router'
import classNames from 'classnames'
import Link from '@/components/Common/Link'

interface SubHeader {
  header?: string
  header_link?: string
  is_active?: boolean
}

export interface NavigationItem {
  header?: string
  header_link?: string
  sub_headers?: SubHeader[]
  is_active?: boolean
}

export interface SearchNav {
  title?: string
  navigations?: NavigationItem[]
}

export interface MutualCategoryNavLinks {
  success?: boolean
  data?: {
    amc_detail?: null
    search_nav?: SearchNav[]
  }
}

const SidebarNav = ({
  linksData,
  addClassName,
}: {
  linksData: SearchNav
  addClassName?: string
}) => {
  const heading = linksData.title ?? ''
  const navigations: Array<NavigationItem> = linksData.navigations ?? []

  const router = useRouter()
  if (!navigations.length) return null
  const checkSamePath = (path: string) => {
    const splits = path.split('indmoney.com')
    return router.asPath.includes(splits[splits.length - 1])
  }
  return (
    <div
      className={classNames(
        'flex w-full flex-col items-start justify-center self-center rounded-md border text-sm',
        addClassName,
      )}
    >
      <div className="border-b-1 flex w-full flex-row items-center justify-between p-2.5 font-medium">
        {heading && <div>{heading}</div>}
      </div>
      <ul className="w-full">
        {navigations.map((el, idx) => (
          <li className="w-full" key={idx}>
            {el.header &&
              (el.header_link ? (
                <Link
                  href={el.header_link}
                  className={classNames(
                    'border-b-1 text-brand-green-dark hover:bg-brand-grey-background block w-full cursor-pointer p-2.5 transition-colors duration-200',
                    {
                      'border-l-brand-blue-azureRadiance border-l-4':
                        checkSamePath(el.header_link) || el.is_active,
                      'font-medium': el.sub_headers?.length,
                    },
                  )}
                >
                  {el.header}
                </Link>
              ) : (
                <div
                  className={classNames(
                    'border-b-1 text-brand-green-dark block w-full p-2.5 transition-colors duration-200',
                    {
                      'font-medium': el.sub_headers?.length,
                    },
                  )}
                >
                  {el.header}
                </div>
              ))}

            {!!el.sub_headers?.length && (
              <ul>
                {el.sub_headers.map((sub, ind) => (
                  <li
                    key={`subheader-${idx}-${ind}`}
                    className={classNames('border-b-1 list-none ', {
                      'last:border-b-0 ': navigations.length < 2,
                    })}
                  >
                    <Link
                      href={sub.header_link ?? '#'}
                      className={classNames(
                        ' hover:bg-brand-grey-background block w-full cursor-pointer p-2.5 transition-colors duration-200',
                        {
                          'border-l-brand-blue-azureRadiance border-l-4 pl-7':
                            checkSamePath(sub.header_link ?? ''),
                          'pl-8':
                            el.header && !checkSamePath(sub.header_link ?? ''),
                        },
                      )}
                    >
                      {sub.header ?? ''}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SidebarNav
